import { createSelector } from 'reselect';

import { coworkingSelector } from '../root/coworkingSelector';

export const getCoworkingUnderground = createSelector(
  coworkingSelector,
  coworking => coworking?.geo.underground || null,
);
